"use client";

import {
  AdminPagination,
  PanelLoader,
  Panel,
  PanelHeader,
  PanelBody,
  PanelError,
} from "@/shared";
import { useRouter, useSearchParams } from "next/navigation";
import { useQuery } from "@tanstack/react-query";
import { adminLogList } from "@/entities";
import { LogsFilter } from "@/features";
import moment from "moment";

export function AdminLogsList() {
  const router = useRouter();
  const searchParams = useSearchParams();

  const type = searchParams?.get("type") || "";
  const keyword = searchParams?.get("keyword") || "";
  const page = parseInt(searchParams?.get("page") || "1");

  const perPage = 15;
  const filterParams = { type, keyword };

  const { error, isLoading, data } = useQuery({
    queryKey: [`admin-logs`, { ...filterParams, page, perPage }],
    queryFn: () => adminLogList({ ...filterParams, page, perPage }),
  });

  if (error) {
    return <PanelError error={error} />;
  }

  if (isLoading) {
    return <PanelLoader panelTitle={`목록(0건)`} />;
  }

  return (
    <>
      <Panel queryKey={[`admin-logs`, { ...filterParams, page, perPage }]}>
        <PanelHeader>목록{!isLoading && `(${data?.count}건)`}</PanelHeader>
        <PanelBody>
          <LogsFilter />

          {data?.count && data?.count > 0 ? (
            <>
              <div className="table-responsive">
                <table className="table table-hover align-middle text-center text-nowrap">
                  <colgroup>
                    <col width="10%" />
                    <col width="70%" />
                    <col width="10%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>회원 정보</th>
                      <th>로그 정보</th>
                      <th>일시</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.result.map((item: any, index: number) => {
                      return (
                        <tr
                          key={index}
                          className={
                            (item.type === "error" && "bg-danger-100") ||
                            (item.type === "info" && "bg-success-100") ||
                            ""
                          }
                        >
                          <td className="text-start">
                            <div>권한 : {item.user_role}</div>
                            <div>아이디 : {item.user?.email}</div>
                          </td>
                          <td className="text-start">
                            <div className="d-flex align-items-center">
                              <div>
                                {/* <div className="text-ellipsis">
                                  테이블 : {item.entity}
                                </div>

                                <div className="text-ellipsis">
                                  기능 : {item.feature}
                                </div> */}

                                <div className="text-ellipsis">
                                  메시지 : {item.message}{" "}
                                  {moment()
                                    .add(-1, "days")
                                    .isBefore(moment(item.created_at)) && (
                                    <span className="badge bg-dark">New</span>
                                  )}
                                </div>
                                <div className="text-ellipsis">
                                  주소 : {item.url}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            {new Date(item.created_at).toLocaleString("ko")}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="d-md-flex align-items-center justify-content-between">
                <div className="me-md-auto text-md-left text-center mb-2 mb-md-0">
                  {data.count}개 항목 중 {(page - 1) * perPage + 1}에서{" "}
                  {data.count < (page - 1) * perPage + perPage
                    ? data.count
                    : (page - 1) * perPage + perPage}
                  까지 표시
                </div>
                <AdminPagination
                  total={Math.ceil(data.count / perPage)}
                  page={page}
                  pathname="/admin/logs"
                  params={filterParams}
                />
              </div>
            </>
          ) : (
            <p className="m-5 text-center">등록된 데이터가 없습니다.</p>
          )}
        </PanelBody>
      </Panel>
    </>
  );
}
